// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__33h28","info":"PatientInfo_info__1a7ey"};